// firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";

// 🔹 Firebase config. Set REACT_APP_FIREBASE_* in the environment to point at a different
// Firebase project (e.g. the company project). The fallbacks below are the legacy project
// (rigby-71325) and are used only when the env vars are absent.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCnHOT7UMG6PAQhAZZ-KuxmKyfJix7UbqI",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "rigby-71325.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "rigby-71325",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "rigby-71325.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "700229794216",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:700229794216:web:73b567184131de0539859d",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || undefined
};

// 🔹 Initialize Firebase
const app = initializeApp(firebaseConfig);
// Analytics is initialized but not used in current implementation
// Uncomment when analytics tracking is needed:
// const analytics = getAnalytics(app);

// 🔹 Initialize Auth + Google Provider
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
// Always show the account chooser so users on shared devices pick the right account
provider.setCustomParameters({ prompt: "select_account" });

// 🔹 Export for use in App.js
export { auth, provider, signInWithPopup };
